import React from 'react';
import { useSelector } from 'react-redux';
import { environmentSelector } from '../redux/appSlice';
import { EnvironmentBadgeView } from './EnvironmentBadgeView';
/** Session-aware wrapper: shows the chip for the current environment (hidden on prod). */
const EnvironmentBadge = () => {
    const environment = useSelector(environmentSelector);
    return <EnvironmentBadgeView environment={environment}/>;
};
export default EnvironmentBadge;
